import { completarComZeroEsquerda, completarComZeroEsquerda8, formatarNumeroComZeros, formatarCodigoCartorio } from './string-utils';

const Helper = {
  formatarCPF(cpf) {
    if (!cpf) return '';
    const cpfLimpo = cpf.toString().replace(/\D/g, '');
    if (cpfLimpo.length === 11) {
      return (
        cpfLimpo.substring(0, 3) +
        '.' +
        cpfLimpo.substring(3, 6) +
        '.' +
        cpfLimpo.substring(6, 9) +
        '-' +
        cpfLimpo.substring(9)
      );
    }
    // Se não conseguir formatar, retorna o CPF original
    return cpf.toString();
  },
  
  // Funções de formatação de string com zeros à esquerda
  completarComZeroEsquerda,
  completarComZeroEsquerda8,
  formatarNumeroComZeros,
  formatarCodigoCartorio,
};

export default Helper;
